import { FormInstance } from 'antd/es/form/Form';
import React, { FC } from 'react';
import {
  JiraConfig,
  JiraProject,
  ProjectMappingMechanism,
} from 'api/integrations';
import { Form } from 'components/atoms/form';
import { Modal } from 'components/atoms/modal';
import { Select } from 'components/atoms/select';
import { useTranslation } from 'hooks/use-translation';
import { FormItem } from '../styles';

type ProjectChangeModal = {
  jiraConfig: JiraConfig;
  projectSelectForm: FormInstance<{ fixedProjectId: number }>;
  jiraProjects: JiraProject[];
  onModalClose: (val: boolean) => void;
  validateProjectChange: (val: ProjectMappingMechanism) => void;
  loading?: boolean;
  selectedProject?: JiraProject;
};

export const ProjectChangeModel: FC<ProjectChangeModal> = ({
  projectSelectForm,
  jiraProjects,
  onModalClose,
  selectedProject,
  loading,
}) => {
  const modalTitle = useTranslation(
    'settings.integrations.jira.choose_project.modal.title',
  );
  const saveText = useTranslation('save');
  const validationMessage = useTranslation('input.required');

  const handleSave = () => {
    projectSelectForm.validateFields().then(() => projectSelectForm.submit());
  };

  return (
    <Modal
      visible
      title={modalTitle}
      confirmLoading={false}
      onCancel={() => onModalClose(false)}
      onOk={handleSave}
      okText={saveText}
    >
      <Form
        initialValues={{
          fixedProjectId: {
            label: selectedProject?.name,
            value: selectedProject?.id,
          },
        }}
        name="projectSelectionForm"
        form={projectSelectForm}
        preserve={false}
      >
        <FormItem
          name="fixedProjectId"
          rules={[{ required: true, message: validationMessage }]}
        >
          <Select
            options={(jiraProjects || [])?.map((jiraProject) => ({
              value: jiraProject.id,
              label: jiraProject.name,
            }))}
            isLoading={loading}
          />
        </FormItem>
      </Form>
    </Modal>
  );
};
